<div
class="toast toast--danger text-white"
role="alert"
aria-live="assertive"
aria-atomic="true"
>
<div class="toast-body text-black"> 
    <div class="toast__wrapper">
  <div class="toast__icon">
    <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Error</title>
        <defs>
            <filter id="filter-1">
                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
            </filter>
        </defs>
        <g id="Style-Guide" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Misc" transform="translate(-677.000000, -530.000000)">
                <rect x="0" y="0" width="2913" height="1000"></rect>
                <g id="Icons" transform="translate(50.000000, 459.000000)">
                    <g transform="translate(0.000000, 68.000000)" id="Icons-/-Error">
                        <g transform="translate(627.209302, 2.000000)">
                            <g id="Color">
                                <g transform="translate(0.000000, 1.000000)">
                                    <path d="M28.7992399,21.070516 L17.9502534,1.93764128 C17.2701858,0.738525799 16.0144426,4.97379915e-14 14.6543074,4.97379915e-14 C13.2941723,4.97379915e-14 12.0380912,0.738181818 11.3580236,1.93764128 L0.510050676,21.070516 C-0.170016892,22.2692875 -0.170016892,23.746683 0.510050676,24.9461425 C1.18978041,26.14457 2.44586149,26.8834398 3.80599662,26.8834398 L25.5032939,26.8834398 C26.8630912,26.8834398 28.1195101,26.144914 28.7995777,24.9461425 C29.4793074,23.746683 29.4793074,22.2692875 28.7992399,21.070516 Z M15.8103885,21.5933661 C15.8103885,22.2101229 15.3191723,22.7099263 14.7137669,22.7099263 L14.6543074,22.7099263 C14.048902,22.7099263 13.5580236,22.2101229 13.5580236,21.5933661 L13.5580236,21.5331695 C13.5580236,20.9164128 14.048902,20.4169533 14.6543074,20.4169533 L14.7137669,20.4169533 C15.3191723,20.4169533 15.8103885,20.9164128 15.8103885,21.5331695 L15.8103885,21.5933661 Z M15.7505912,18.1539066 C15.7505912,18.7706634 15.2600507,19.2704668 14.6543074,19.2704668 C14.048902,19.2704668 13.5580236,18.7706634 13.5580236,18.1539066 L12.8472128,8.01611794 C12.8472128,7.39970516 14.0492399,6.65842752 14.6546453,6.65842752 C15.2603885,6.65842752 16.4624155,7.39970516 16.4624155,8.01611794 L15.7505912,18.1539066 Z" id="Shape" fill="#fe5353" fill-rule="nonzero"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  </div>
  <div class="toast__content">
    <div class="toast__type text-dark">Error</div>
    <div class="toast__message">{{message}}</div>
  </div>
    </div>
</div>
</div>